import script from "./ConvertNoteToTask.vue?vue&type=script&setup=true&lang=js"
export * from "./ConvertNoteToTask.vue?vue&type=script&setup=true&lang=js"

import "./ConvertNoteToTask.vue?vue&type=style&index=0&id=4bc02c92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bc02c92"]])

export default __exports__